'use strict';
import Console from '../ConsoleShim.js';
import Http from 'axios';
import React from 'react';

/**
 * Guides the user through the remaining steps to complete phone based
 * authentication if they selected that from the start screen.
 * 
 * @export
 * @class ViewPhoneAuthentication
 * @extends {React.Component}
 */
export default class ViewPhoneAuthentication extends React.Component {

    constructor(props) {
        super(props);

        // Set initial state
        this.state = {
            //sessionStatus: (props.params.status) ? parseInt(props.params.status) : 2
            sessionStatus: 2
        };

        // Bind non-React functions
        this.checkSessionStatus = this.checkSessionStatus.bind(this);
    }

    /**
     * Get the latest session status from the server
     */
    /*
    async checkSessionStatus() {
        try {
            // Query the server for current status
            let response = await Http.get(`/flow/status/${fhda.sessionId}`);
            Console.log('Received session status update', response.data);

            // // Update component state
            this.setState({ sessionStatus: response.data.status});
        }
        catch(error) {
            // Activate the error view
            Console.log('HTTP web service /flow/status returned error', error);
            this.props.router.push(`/error`);
        }
    }
    */
    
    checkSessionStatus() {
        // Query the server for current status
        Http.get(`/flow/status/${fhda.sessionId}`)
            .then(response => {
                //Console.log('Received session status update', response.data);

                // Update component state
                this.setState({ sessionStatus: response.data.status});
            })
            .catch(error => {
                //Console.log('HTTP web service /flow/status returned error', error);
                
                // Activate the error view                
                this.props.router.push(`/error`);
            });
    }

    componentDidMount() {
        // Create a timer to watch session status from the server
        this.statusTimer = setInterval(this.checkSessionStatus, 1000);
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.sessionStatus === 3) {
            // On authenticated, activate password editor view
            this.props.router.push(`/newpw`);
        }
        else if(nextState.sessionStatus !== 2) {
            // Clear interval timer (if exists)            
            clearInterval(this.statusTimer);
            // Console.log('Cleared session status timer (componentWillUpdate)');
        }
    }

    componentWillUnmount() {
        // Clear interval timer (if exists)
        if(this.statusTimer) { 
            clearInterval(this.statusTimer);
            // Console.log('Cleared session status timer (componentWillUnmount)');
        }
    }

    /**
     * Default view to render if the session status does not have an
     * authentication result
     */
    renderDefault() {
        return <div>
            <h4>Be ready to answer your phone...</h4>

            <div className="phone-waiting-indicator">
                <p>Waiting to complete call</p>
            </div>

            <p>
                After successfully proving your identity, this screen will
                update and you will have the option to choose a new password.
            </p>

            <p>
                <strong>If you are on a mobile device</strong>, some phones switch
                between data and voice service when receiving calls. Please be
                patient while waiting for the screen to refresh.
            </p>

            <p>
                <a href="/resetpwd" className="btn btn-warning">
                    <i className="fa fa-refresh"></i> Start Over
                </a>
            </p>
        </div>;
    }

    /**
     * Failure messaging to display to the user if they could not successfully
     * complete the authentication challenge 
     */
    renderAuthenticationFailed() {
        return <div>
            <div className="alert alert-danger">
                <strong>Authentication Failed</strong><br/>
            </div>
            <p>
                We could not verify your identity. At this time, you are not
                permitted to change your password online. You may try again.
            </p>
            <p>
                If you are failing the authentication test multiple times, it
                will be necessary for you to visit a college in person with
                a government-issue ID in order to prove your identity.
            </p>
            <p>
                <a className="btn btn-default" href="/resetpwd">
                    <i className="fa fa-refresh"></i> Start Over
                </a>
            </p>
        </div>;
    }

    /**
     * Messaging to display to the user if the authentication call timed out,
     * and they did not complete it in time
     */
    renderAuthenticationTimedout() {
        return <div>
            <div className="alert alert-warning">
                <strong>Session Timed Out</strong><br/>
            </div>
            <p>
                For your security, we have detected that your session idle and
                have expired it. Please start the authentication process again
                when you are ready to accept the phone call.
            </p>
            <p>
                <a className="btn btn-default" href="/resetpwd">
                    <i className="fa fa-refresh"></i> Start Over
                </a>
            </p>
        </div>;
    }

    render () {
        if(this.state.sessionStatus === 4) {
            return this.renderAuthenticationFailed();
        }
        else if(this.state.sessionStatus === 6) {
            return this.renderAuthenticationTimedout();
        }
        return this.renderDefault();
    }   

}


// WEBPACK FOOTER //
// ./src/react/views/PhoneAuthentication.jsx